import { render, staticRenderFns } from "./OrderLinkNextSteps.vue?vue&type=template&id=20e90412&scoped=true"
import script from "./OrderLinkNextSteps.vue?vue&type=script&lang=js"
export * from "./OrderLinkNextSteps.vue?vue&type=script&lang=js"
import style0 from "./OrderLinkNextSteps.vue?vue&type=style&index=0&id=20e90412&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e90412",
  null
  
)

export default component.exports